import * as config from './../config/config'
import api from './interceptor'


export async function createEntretien(data) {
    try {
        const response = await api.post(config.REACT_APP_ENDPOINT_CREATE_ENTRETIEN, {
           "camion_id": data["camion_id"], 
           "description": data["description"],
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}


export async function getEntretien() {
    try {
        const response = await api.get(config.REACT_APP_ENDPOINT_LIST_ENTRETIEN);
        return response.data;
    } catch (error) {
        throw error;
    }
}
